import { render, staticRenderFns } from "./DatasetUpdate.vue?vue&type=template&id=785f0a2b&scoped=true"
import script from "./DatasetUpdate.vue?vue&type=script&lang=js"
export * from "./DatasetUpdate.vue?vue&type=script&lang=js"
import style0 from "./DatasetUpdate.vue?vue&type=style&index=0&id=785f0a2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785f0a2b",
  null
  
)

export default component.exports